// extracted by mini-css-extract-plugin
export default {"container":"styles_container__IJyge","loader":"styles_loader__+92IG"};